// extracted by mini-css-extract-plugin
export default {"header":"_96L21","title":"PDxlY","divider":"KwkF3","content":"XJwTV"};